import axios from "axios";

// Keep Admin and API on the same deployment origin.
export const API_BASE = "/api";

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("slr_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
